import React from 'react'
import { ReactComponent as LeftIcon } from './../../assets/new-icons/arrows.svg'
import { ReactComponent as QuestionIcon } from './../../assets/new-icons/hoi.svg'
import Arrow from '../../assets/new-icons/Arrow 7.png'
import './index.scss'
import { useHistory, useLocation } from 'react-router-dom'
import useWindowDimensions from 'hooks/window-dimensions'
import { MESSAGE_BACK_TO_HOME_MINI_APP } from '../../constants/params'
import { useAppParamsContext } from 'contexts/AppParamsContext'
import { DEFAULT_HOME_LAYOUT } from 'App'

const ROOT_PATHS = new Set(['/automated-traffic-fine-notification/vehicles', '/stations'])

const StickyHeader = ({
  className,
  icon = <span></span>,
  showArrowLeft = true,
  title = null,
  // backgroundColor = 'white',
  // borderColor = '#0C42BC',
  // color = '#0C42BC',
  customBackPath = null,
  onGoBack,
  askQuestionButtonVisible = false,
  askQuestionButtonActionUrl = null,
  breakpoint = 600
}) => {
  const { width } = useWindowDimensions()
  const history = useHistory()
  const { pathname } = useLocation()
  const { isHeaderMiniApp, isEmbeddedView } = useAppParamsContext()
  const headerTitle = title ? title[0].toUpperCase() + title.slice(1) : ''
  const { search } = useLocation()
  const params = new URLSearchParams(search)

  const handleBack = () => {
    if (
      isHeaderMiniApp &&
      (ROOT_PATHS.has(pathname) || (Boolean(DEFAULT_HOME_LAYOUT?.[process.env.REACT_APP_DEFAULT_HOME_LAYOUT]) && pathname === '/'))
    ) {
      if (window.parent) {
        window.parent.postMessage({ key: MESSAGE_BACK_TO_HOME_MINI_APP }, '*')
      }
      return
    }

    if (onGoBack) {
      onGoBack()
    } else if (customBackPath && showArrowLeft) {
      history.push(customBackPath)
    } else {
      history.goBack()
    }
  }

  if (width < breakpoint) {
    return (
      <>
        {!(isEmbeddedView && !isHeaderMiniApp) && (
          <div className={`sticky-header ${className || ''} ${isHeaderMiniApp ? 'mini-app-header-mobile' : ''}`}>
            <div
              style={{
                visibility: showArrowLeft ? 'visible' : 'hidden'
              }}
              onClick={handleBack}
              className="cursor">
              <img src={Arrow} />
            </div>
            <div className="sticky-header-title">
              {icon}
              <span className="mx-2" style={{ color: 'white' }}>
                {headerTitle}
              </span>
            </div>
            <div
              style={{ visibility: askQuestionButtonVisible ? 'visible' : 'hidden' }}
              className=" cursor style-color"
              onClick={() => {
                history.push(askQuestionButtonActionUrl)
              }}>
              <QuestionIcon width="16px" height="16px" color="#0C42BC" />
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {!(isEmbeddedView && !isHeaderMiniApp) && (
        <div className={`desktop-header ${className || ''} ${isHeaderMiniApp ? 'mini-app-header-desktop' : ''}`}>
          <div
            style={{
              visibility: showArrowLeft ? 'visible' : 'hidden'
            }}
            onClick={handleBack}
            className="cursor back-btn">
            <LeftIcon />
          </div>
          <div className="desktop-header-title">
            {icon}
            <span className="mx-2">{headerTitle}</span>
          </div>
          <div
            style={{ visibility: askQuestionButtonVisible ? 'visible' : 'hidden' }}
            className="p-2 cursor style-color"
            onClick={() => {
              history.push(askQuestionButtonActionUrl)
            }}>
            <QuestionIcon width="17px" height="17px" color="#0C42BC" />
          </div>
        </div>
      )}
    </>
  )
}

export const StickyHeaderContainer = (props) => {
  return (
    <div style={{ maxWidth: 600, width: '100%', margin: 'auto' }}>
      <StickyHeader {...props} />
    </div>
  )
}

export default StickyHeader
